'use client';

import { Button, Input } from '@repo/ui';
import { Search } from 'lucide-react';
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';

export function NotFoundSearch(): JSX.Element {
  const t = useTranslations('errors.notFound.search');
  return (
    <search className="w-full max-w-md">
      <form action="/search" method="get" className="flex w-full gap-2">
        <div className="relative flex-1">
          <Search
            className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
            aria-hidden
          />
          <Input
            type="search"
            name="q"
            placeholder={t('placeholder')}
            aria-label={t('placeholder')}
            className="h-10 pl-9"
            autoComplete="off"
          />
        </div>
        <Button type="submit" variant="secondary" className="h-10">
          {t('submit')}
        </Button>
      </form>
    </search>
  );
}
